import styles from "./promotionalbanner.module.css";

const PromotionalBanner = () => {
  return (
    <section className={styles.promotional__wrapper}>
      <img
        src="/assets/img/collections/promotionalb.png"
        alt="Promotional Banner"
        className={styles.banner__image}
      />

      {/* Overlay text */}
      {/* <div className={styles.banner__content}>
        <span className={styles.badge}>
          Trending Products
        </span>

        <h1 className={styles.title}>
          Get 30% Discount On All Hoodies!
        </h1>

        <div className={styles.brand__list}>
          <span>✓ Zara</span>
          <span>✓ Gucci</span>
          <span>✓ Publo</span>
          <span>✓ Men's</span>
          <span>✓ Women's</span>
        </div>
      </div> */}
    </section>
  );
};

export default PromotionalBanner;